export default __webpack_public_path__ + "static/media/rosella.36df9a19.jpg";